module.exports = __webpack_public_path__ + "img/Reed_Hall-_NE-t-21526-004.8847e7c7.jpg";